import React from 'react';

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.links = props.links || [];
    }

    render() {
        return (
            <nav className="navbar navbar-toggleable-md navbar-light main-navbar d-flex justify-content-center navbar-custom-wrapper">
                    <span id="navbar-name" className="font-satisfy font-brown">
                        Deanna Dunmyer
                    </span>

                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"/>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav" style={{listStyle: 'none', width: '100%'}}>
                            {  this.links.map((link, index) => <li key={index} className="nav-item">
                                <a className={"nav-link font-josefin "+ link.extraClasses} href={link.reference}>{link.text}</a>
                            </li>)  }
                        </ul>
                    </div>
            </nav>
        );
    }
}

export default Navbar;